module.exports = __webpack_public_path__ + "static/media/successIcon.92e7bf86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/successIcon.svg
// module id = 1896
// module chunks = 0